import { render, staticRenderFns } from "./DoctorList.vue?vue&type=template&id=53fb5bd9&scoped=true"
import script from "./DoctorList.vue?vue&type=script&lang=ts"
export * from "./DoctorList.vue?vue&type=script&lang=ts"
import style0 from "./DoctorList.vue?vue&type=style&index=0&id=53fb5bd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fb5bd9",
  null
  
)

export default component.exports